import React, { lazy } from "react";
import DashboardLayout from "./Layout/DashboardLayout";
import { Navigate } from "react-router-dom";
import AppraisalSetup from "./pages/AppraisalManagment/AppraisalSetup";
import AppraisalForm from "./pages/AppraisalManagment/AppraisalSetup/AppraisalForm/AppraisalForm";
import SetupCaregory from "./pages/AppraisalManagment/AppraisalSetup/SetupCategory/SetupCaregory";
import Appraisal from "./pages/AppraisalManagment/Appraisal";
import QuarterlyAppraisal from "./pages/AppraisalManagment/Appraisal/QuarterlyAppraisalProgess";
import QuarterlyAppraisalView from "./pages/AppraisalManagment/Appraisal/QuarterlyAppraisalView";
import ProbationalAppraisal from "./pages/AppraisalManagment/Appraisal/ProbationalAppraisalProgress";
import YearlyAppraisalList from "./pages/AppraisalManagment/Appraisal/YearlyAppraisalList";
import YearlyAppraisalView from "./pages/AppraisalManagment/Appraisal/YearlyAppraisalView";
import AppraisalProgressForm from "./pages/AppraisalManagment/Appraisal/AppraisalProgressForm/AppraisalProgressForm";
import MonthlyAppraisalView from "./pages/AppraisalManagment/Appraisal/MonthlyAppraisalView";
import User from "pages/AccessManagement/User";
import RoleAccess from "pages/AccessManagement/RoleAccess";
import RoleList from "pages/AccessManagement/Roles";
import UserManageObject from "pages/AccessManagement/Objects";
import Sections from "pages/AppraisalManagment/Sections";
import Error_404 from "pages/Errors/Error_404";
import Error_401 from "pages/Errors/Error_401";
import Dashboard from "pages/Dashboard";
import PafCalendar from "pages/PafCalendar";
import QuarterlyReports from "pages/Reports/QuarterlyReports";
import MonthlyReports from "pages/Reports/MonthlyReports";
import MyPafs from "pages/AppraisalManagment/MyPafs";
import MyPafView from "pages/AppraisalManagment/MyPafs/MyPafView";
import EmployeePafSign from "pages/AppraisalManagment/MyPafs/EmployeePafSign";
import { ROUTE } from "pages/AppraisalManagment/constants/legacyApiKeys";
import PafSettings from "pages/Settings/PafSettings";
import PafDesignation from "pages/Settings/PafDesignation";
import {
  PafEngineDashboard,
  PafEngineGlobalSettings,
  PafEnginePolicies,
  PafEngineSimulation,
  PafEngineGenerate,
  PafEngineLogs,
} from "pages/PafEngine";
import {
  EmailTemplates,
  EmailReminders,
  EmailMailLogs,
  EmailSmtpSettings,
} from "pages/EmailSettings";
import UserManual from "pages/KnowledgeBase";
// const Commitee = lazy(() => import("pages/Commitee"));

const routes = [
  {
    path: "/",
    element: <DashboardLayout />,
    children: [
      {
        index: true, // Default child route
        element: <Dashboard />,
      },
      
      {
        path: "appraisalSetup",
        element: <AppraisalSetup />,
      },

      {
        path: "appraisalSetup/add",
        element: <AppraisalForm />,
      },
      {
        path: "appraisalSetup/update",
        element: <AppraisalForm />,
      },
      {
        path: "appraisalSetup/view",
        element: <AppraisalForm />,
      },

      {
        path: "setupCategory",
        element: <SetupCaregory />,
      },

      {
        path: "appraisal",
        element: <Appraisal />,
      },
      {
        path: "monthlyappraisals",
        element: <Navigate to="/appraisal" replace />,
      },
      {
        path: "quarterly-appraisal",
        element: <QuarterlyAppraisal />,
      },
      {
        path: "quarterly-appraisal/paf/view",
        element: <MonthlyAppraisalView />,
      },
      {
        path: "quarterly-appraisal/view",
        element: <QuarterlyAppraisalView />,
      },
      {
        path: "probational-appraisals",
        element: <ProbationalAppraisal />,
      },
      {
        path: "probational-appraisals/view",
        element: <QuarterlyAppraisalView />,
      },
      {
        path: "probationary-appraisals",
        element: <ProbationalAppraisal />,
      },
      {
        path: "probationary-appraisals/view",
        element: <QuarterlyAppraisalView />,
      },
      {
        path: "yearly-appraisals",
        element: <YearlyAppraisalList />,
      },
      {
        path: "yearly-appraisals/paf/view",
        element: <MonthlyAppraisalView />,
      },
      {
        path: "yearly-appraisals/view",
        element: <YearlyAppraisalView />,
      },

      {
        path: "appraisalprogressform",
        element: <AppraisalProgressForm />,
      },
      {
        path: "appraisalprogressform/:id",
        element: <AppraisalProgressForm />,
      },

      {
        path: "monthlyappraisalview",
        element: <MonthlyAppraisalView />,
      },
      {
        path: "monthlyappraisalreport",
        element: <MonthlyAppraisalView />,
      },
      {
        path: "sections",
        element: <Sections />,
      },
      {
        path: ROUTE.redirectFromLegacyAlias,
        element: <Navigate to="/sections" replace />,
      },

      {
        path: "user",
        element: <User/>,
      },

      {
        path: "role_access",
        element: <RoleAccess/>,
      },

      {
        path: "roles",
        element: <RoleList/>,
      },

      {
        path: "object",
        element: <UserManageObject/>,
      },

      {
        path: "dashboard",
        element: <Dashboard />,
      },

      {
        path: "pafCalendar",
        element: <PafCalendar />,
      },

      {
        path: "quarterly-reports",
        element: <QuarterlyReports />,
      },

      {
        path: "monthly-reports",
        element: <MonthlyReports />,
      },

      {
        path: "my-pafs",
        element: <MyPafs />,
      },
      {
        path: "my-pafs/view",
        element: <MyPafView />,
      },
      {
        path: "emp-paf-sign/:id",
        element: <EmployeePafSign />,
      },
      {
        path: "paf-settings",
        element: <PafEngineDashboard />,
      },
      {
        path: "paf-settings/global-settings",
        element: <PafEngineGlobalSettings />,
      },
      {
        path: "paf-settings/policies",
        element: <PafEnginePolicies />,
      },
      {
        path: "paf-settings/simulation",
        element: <PafEngineSimulation />,
      },
      {
        path: "paf-settings/generate",
        element: <PafEngineGenerate />,
      },
      {
        path: "paf-settings/logs",
        element: <PafEngineLogs />,
      },
      {
        path: "Paf-designation",
        element: <PafDesignation />,
      },
      {
        path: "paf-generation-settings",
        element: <PafSettings />,
      },
      {
        path: "paf-engine",
        element: <Navigate to="/paf-settings" replace />,
      },
      {
        path: "paf-engine/global-settings",
        element: <Navigate to="/paf-settings/global-settings" replace />,
      },
      {
        path: "paf-engine/policies",
        element: <Navigate to="/paf-settings/policies" replace />,
      },
      {
        path: "paf-engine/simulation",
        element: <Navigate to="/paf-settings/simulation" replace />,
      },
      {
        path: "paf-engine/generate",
        element: <Navigate to="/paf-settings/generate" replace />,
      },
      {
        path: "paf-engine/logs",
        element: <Navigate to="/paf-settings/logs" replace />,
      },

      {
        // React Router normalizes the trailing slash, so this also covers "email-settings/".
        path: "email-settings",
        element: <Navigate to="/email-settings/templates" replace />,
      },
      {
        path: "email-settings/templates",
        element: <EmailTemplates />,
      },
      {
        path: "email-settings/reminders",
        element: <EmailReminders />,
      },
      {
        path: "email-settings/logs",
        element: <EmailMailLogs />,
      },
      {
        path: "email-settings/smtp",
        element: <EmailSmtpSettings />,
      },
      {
        path: "user-manual",
        element: <UserManual />,
      },

      {
        path: "errors",
        children: [
          {
            path: "error-404",
            element: <Error_404 />,
          },
          {
            path: "error-401",
            element: <Error_401 />,
          },
        ],
      },
    ],
  },
];

export default routes;
 